"use client";
import { useState } from "react";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import MyMarquee from "@/components/ui/marquee";
import type { Notice } from "@/lib/types";
import { Button } from "./ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./ui/carousel";

export function NoticeContent({ notice }: { notice: Notice[] }) {
  const firstNotice = notice[0];
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setIsDialogOpen(true)}
        type="button"
        className="cursor-pointer text-accent-foreground"
      >
        <MyMarquee text={firstNotice?.content || ""} />
      </button>

      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="flex h-[400px] w-[520px] max-w-[520px] flex-col justify-between px-0 py-4">
          <DialogTitle className="text-center text-base">公告</DialogTitle>
          <div className="flex max-h-[300px] flex-1 items-center justify-center overflow-auto border-gray-200 border-t pt-2 pb-4 ">
            <Carousel className="h-[230px] w-full max-w-[80%] bg-[#F7F8FA]">
              <CarouselContent>
                {notice.map((item) => (
                  <CarouselItem key={item.id}>
                    <div className="flex h-full items-center justify-center">
                      <div className="max-h-[190px] overflow-y-auto p-4">
                        {item.content || ""}
                      </div>
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </div>
          <Button
            className="mx-13 bg-primary text-white"
            onClick={() => setIsDialogOpen(false)}
          >
            确定
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
